/*
  Product card add-to-cart, used by every grid that renders product-grid-item
  (collection, search, related and featured products).

  Each single-variant card renders two buttons:
    .ajax-add-to-cart       - the real submit button. Handled by the delegated
                              jQuery click handler in layout.theme.js, so it is
                              kept hidden until that script has run.
    .ajax-add-to-cart-extra - pre-hydration fallback that posts to /cart/add.js
                              on its own. Hidden once the real button is live.

  This is a custom element so cards appended by collection-infinite-scroll.js
  wire themselves up in connectedCallback. The previous one-shot `window.load`
  pass had already fired by the time those cards were inserted, which left them
  with a dead fallback button and a permanently hidden real button.
*/
(function () {
  'use strict';

  // Resolves once layout.theme.js has bound its delegated .ajax-add-to-cart
  // handler. Shared by every card so we bind a single load listener, not one
  // per product.
  var themeReady =
    document.readyState === 'complete'
      ? Promise.resolve()
      : new Promise(function (resolve) {
          window.addEventListener('load', resolve, { once: true });
        });

  function markCartOpenRequest() {
    var url = new URL(window.location.href);
    if (!url.pathname.endsWith('/')) url.pathname += '/';
    url.searchParams.set('viewcart', 'true');
    window.history.pushState({ path: url.href }, '', url.href);
  }

  function clearCartOpenRequest() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('viewcart')) return;
    url.searchParams.delete('viewcart');
    window.history.replaceState(null, '', url.href);
  }

  class CollectionAddToCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.ajaxButton = this.querySelector('.ajax-add-to-cart');
      this.fallbackButton = this.querySelector('.ajax-add-to-cart-extra');

      if (this.fallbackButton) {
        this.fallbackButton.addEventListener('click', this.onFallbackClick.bind(this));
      }

      themeReady.then(this.activateAjaxButton.bind(this));
    }

    activateAjaxButton() {
      if (this.ajaxButton) this.ajaxButton.classList.remove('hide');
      if (this.fallbackButton) this.fallbackButton.classList.add('hide');
    }

    onFallbackClick(event) {
      event.preventDefault();
      event.stopPropagation();

      // Quick-add panels (multi-variant cards) put a checked variant radio
      // named "id" in the form; single-variant cards fall back to the
      // static variant-id attribute on the button itself.
      var form = this.querySelector('form');
      var checkedVariant = form ? form.querySelector('input[name="id"]:checked') : null;
      var variantId = checkedVariant ? checkedVariant.value : this.fallbackButton.getAttribute('variant-id');
      if (!variantId) return;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          markCartOpenRequest();
          // Matches the jQuery-handled real button's success signal so
          // listeners (mini-cart badge, quick-add feedback) fire either way.
          if (window.jQuery) jQuery('body').trigger('updated-mini-cart');
        })
        .catch(function (error) {
          console.error('Error adding product to cart:', error);
        });
    }
  }

  if (!customElements.get('collection-add-to-cart')) {
    customElements.define('collection-add-to-cart', CollectionAddToCart);
  }

  themeReady.then(function () {
    setTimeout(clearCartOpenRequest, 2000);
  });
})();
